import { ContainerStatusFinancial } from './styles';
import { useI18n } from '../../shared/i18n';

interface IStatusFinancialProps {
  status: number | undefined;
}

export const StatusFinancial: React.FC<IStatusFinancialProps> = ({
  status,
}) => {
  const { t } = useI18n();
  let result = { name: '', color: '' };

  switch (status) {
    case 1:
      result = { name: t('statusFinancial.open'), color: '#a9a9a9' };
      break;
    case 2:
      result = { name: t('statusFinancial.paid'), color: '#32cf5c' };
      break;
    case 3:
      result = { name: t('statusFinancial.overdue'), color: '#FFC107' };
      break;
    default:
      result = { name: t('statusFinancial.cancelled'), color: '#ed4140' };
      break;
  }

  return (
    <ContainerStatusFinancial color={result.color}>
      {result.name}
    </ContainerStatusFinancial>
  );
};
